// composables/useOrderConfirm.ts
import {useRoute} from 'vue-router'
import {usePay} from '~/composables/usePay'

export function useOrderConfirm() {
    const route = useRoute()
    const {confirmOrderStatus} = usePay()

    /**
     * 检查订单并返回结果（带轮询）
     */
    const checkAndHandleOrder = async (
        maxRetries = 15,       // 最大轮询次数
        interval = 2000       // 每次轮询间隔，单位 ms
    ) => {
        const commit = route.query.commit // paypal用这个判断支付状态
        const status = route.query.status
        const payChannel = route.query.pay_channel
        const type = route.query.payment_type
        console.log('类型', commit)

        // 1. 如果是用户取消 → 弹挽留弹窗
        if ((commit === 'cancel' && payChannel === 'paypal') || status === 'CLOSED') {
            return {
                action: 'RechargeFailed',
                type: type === 'subscription' ? 2 : 1
            }
        }

        // 2. 确认订单
        if ((commit === 'confirm' && payChannel === 'paypal') || status === 'SUCCESS') {
            let res: any = null
            for (let i = 0; i < maxRetries; i++) {
                res = await confirmOrderStatus()
                console.log(`第${i + 1}次轮询结果:`, res)

                if (res && res.code === 0 && res.data?.order?.status === 1) {
                    return {
                        action: [1,3].includes(res.data?.order?.order_type) ? 'CoinsBuySuccess' : 'PayVipSuccess',
                        type: res.data?.order?.order_type, // 1=金币，2=会员
                        extraData: res.data
                    }
                }

                // 如果不是最后一次 → 等待 interval 再重试
                if (i < maxRetries - 1) {
                    await new Promise(resolve => setTimeout(resolve, interval))
                }
            }

            // 多次轮询后仍未成功
            return {
                action: 'RechargeFailed',
                type: type === 'subscription' ? 2 : 1,
                msg: '订单确认失败'
            }
        }

        return {action: 'none'} // 默认失败
    }

    return {checkAndHandleOrder}
}
